import { getCurrentUserForOAuth } from '@/helpers/AuthHelper';
import {
	OAUTH_LOGIN_USER,
	OAUTH_LOGIN_USER_SUCCESS,
	OAUTH_LOGIN_USER_ERROR,
	OAUTH_SELECT_BRANCH,
	OAUTH_SELECT_BRANCH_SUCCESS,
	OAUTH_SELECT_BRANCH_ERROR,
} from '../actions-registry';

const INIT_STATE = {
	currentUser: getCurrentUserForOAuth(),
	loading: false,
	error: '',
};

export default (state = INIT_STATE, action) => {
	switch (action.type) {
		case OAUTH_LOGIN_USER:
			return { ...state, loading: true, error: '' };
		case OAUTH_LOGIN_USER_SUCCESS:
			return {
				...state,
				loading: false,
				currentUser: action.payload,
				error: '',
			};
		case OAUTH_LOGIN_USER_ERROR:
			return {
				...state,
				loading: false,
				currentUser: null,
				error: action.payload.message?.message?.toString(),
			};
		case OAUTH_SELECT_BRANCH:
			return { ...state, loading: true, error: '' };
		case OAUTH_SELECT_BRANCH_SUCCESS:
			return {
				...state,
				loading: true, // 因为成功，马上要跳新页面，他就别点了
				error: '',
			};
		case OAUTH_SELECT_BRANCH_ERROR:
			return {
				...state,
				loading: false,
				error: action.payload.message?.message?.toString(),
			};
		default:
			return { ...state };
	}
};
